// removed by extract-text-webpack-plugin
module.exports = {"tariff-card":"theme--tariff-card--2KFy2Qvs","tariffCard":"theme--tariff-card--2KFy2Qvs"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/tariffCard/theme.scss
// module id = 977
// module chunks = 0